import MainLayout from '@/common/components/layouts/MainLayout';
import { PropsWithChildren } from 'react';

const PropertyInsurance = ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title={' زیان‌دیده / بیمه شخص ثالث '} header="titleHeader">
      {children}
    </MainLayout>
  );
};

export default PropertyInsurance;
